export declare namespace AppEditableRowTableTokenSections {
	interface Wrapper {
		overflowX: string;
		overflowY: string;
		scrollbarGutter: string;
	}

	interface Table {
		minWidth: string;
	}

	interface Th {
		background: string;
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
		padding: string;
		borderBottomWidth: string;
		borderBottomColor: string;
	}

	interface Td {
		padding: string;
		fontSize: string;
		verticalAlign: string;
	}

	interface Row {
		background: string;
		borderColor: string;
	}
}

export type AppEditableRowTableTokens = {
	wrapper: AppEditableRowTableTokenSections.Wrapper;
	table: AppEditableRowTableTokenSections.Table;
	th: AppEditableRowTableTokenSections.Th;
	td: AppEditableRowTableTokenSections.Td;
	row: AppEditableRowTableTokenSections.Row;
};

export const wrapper: AppEditableRowTableTokenSections.Wrapper = {
	overflowX: 'auto',
	overflowY: 'visible',
	/** Reserves the scrollbar's room up front, so a scrollbar that appears for a moment does not shift the table. */
	scrollbarGutter: 'stable',
};

export const table: AppEditableRowTableTokenSections.Table = {
	minWidth: '100%',
};

/** The column headers; a cell's stacked label below `lg` takes the same text styling. */
export const th: AppEditableRowTableTokenSections.Th = {
	background: '{primary.50}',
	color: '{surface.800}',
	fontSize: '0.75rem',
	fontWeight: '500',
	lineHeight: '1.25rem',
	padding: '8px 16px',
	borderBottomWidth: '1px',
	borderBottomColor: '{surface.200}',
};

export const td: AppEditableRowTableTokenSections.Td = {
	padding: '8px',
	fontSize: '0.875rem',
	verticalAlign: 'top',
};

/** Each body row: its background and the divider under it. */
export const row: AppEditableRowTableTokenSections.Row = {
	background: '{surface.0}',
	borderColor: '{surface.200}',
};

/** `app-editable-row-table`: the scroll wrapper, the column headers, the body cells and the rows' dividers. */
export default {
	wrapper,
	table,
	th,
	td,
	row,
} satisfies AppEditableRowTableTokens;
